import React, { useState, useEffect } from 'react';
import '../styles/Carousel.css';

const images = [
    '/foto/unnamed.webp',
    '/foto/unnamed (1).webp',
    '/foto/unnamed (9).webp',
    '/foto/unnamed (10).webp',
    '/foto/unnamed (11).webp',
    '/foto/unnamed (12).webp',
];

const Carousel = () => {
    const [current, setCurrent] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsTransitioning(true);
            
            setTimeout(() => {
                setCurrent((prev) => (prev + 1) % images.length);
                setIsTransitioning(false);
            }, 250); // metà del tempo di transizione CSS (0.5s / 2)
        }, 5000); // cambia immagine ogni 5 secondi
        
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="carousel-viewport">
            {/* Sfondo sfocato che riempie la viewport */}
            <img
                src={images[current]}
                alt=""
                aria-hidden="true"
                className={`carousel-img bg ${isTransitioning ? 'fade-out' : 'fade-in'}`}
            />
            {/* Immagine principale non tagliata */}
            <img
                src={images[current]}
                alt={`foto ${current}`}
                className={`carousel-img fg ${isTransitioning ? 'fade-out' : 'fade-in'}`}
            />
        </div>
    );
};

export default Carousel;